import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';

export const listingFilters = () => {
  Alpine.data('listingFilters', () => ({
    filtersOpen: false,
    init() {
      this.filtersOpen = !breakpoint.isMobile;
    },
    bindListings: {
      // eslint-disable-next-line func-names
      '@resize.window.stop.debounce': function () {
        this.filtersOpen = !breakpoint.isMobile;
      },
    },
  }));
};
